import React from "react"
import * as styles from "./HeroSectionCenterTextWithImage.module.scss"

import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import { useLink } from "../../hooks/index"
import { RichText } from "../RichText/RichText"
import BreadcrumbThree from "../BreadcrumbThree/BreadcrumbThree"

const HeroSectionCenterTextWithImage = ({ data }) => {
    const {
        name,
        title,
        subTitle,
        cta,
        description,
        heroImage,
        mobileImage,
        tagline,
        breadcrum,
    } = data

    return (
        <section className={`text-white ${styles.container}`}>
            {breadcrum && (
                <div className={`container ${styles.breadcrumContainer}`}>
                    <BreadcrumbThree data={breadcrum} title={title} />
                </div>
            )}
            <div className={` ${styles.containerWithoutPadding}`}>
                <div className={`container ${styles.textContainer}`}>
                    {tagline && <p className={`global-spacing-bottom`}>{tagline}</p>}
                    {title && <h1 className=" global-spacing-bottom">{title}</h1>}
                    {description && (
                        <p>
                            <RichText content={description} />
                        </p>
                    )}
                    {cta && (
                        <ul className={`flex items-center global-spacing-top ${styles.btn}`}>
                            {cta?.map((item, index) => (
                                <li key={item.slug || item.id}>
                                    {" "}
                                    <Link
                                        to={`${useLink(item.target?.slug || item.slug)}`}
                                        className={
                                            index === 0 ? "primaryFilled" : "onPrimaryOutline"
                                        }
                                        title={item.title}
                                    >
                                        {item.title === "Learn more" ? (
                                            <>
                                                {item.title}{" "}
                                                <span className="sr_only">
                                                    {`Explore further content"`}{" "}
                                                </span>{" "}
                                            </>
                                        ) : (
                                            item.title
                                        )}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    )}

                </div>
                <div className={styles.heroImg}>
                    {heroImage?.gatsbyImageData && (
                        <GatsbyImage
                            image={heroImage.gatsbyImageData}
                            alt={heroImage.title || "Hero Image"}
                            loading="eager"
                            fetchPriority="high"
                            layout="constrained"
                            className={`container ${styles.heroImageGlobal}`}
                        />
                    )}
                    {mobileImage?.gatsbyImageData && (
                        <GatsbyImage
                            image={mobileImage.gatsbyImageData}
                            alt={mobileImage.title || "Hero Image"}
                            loading="eager"
                            fetchPriority="high"
                            layout="constrained"
                            className={`container ${styles.mobileImageGlobal}`}
                        />
                    )}
                </div>
            </div>

        </section>
    )
}

export default HeroSectionCenterTextWithImage
